import { CoursesTypes } from './types';

export const getDataCourse = (course_id: number) => ({
  types: [
    CoursesTypes.GET_COURSE_REQUEST,
    CoursesTypes.GET_COURSE_SUCCESS,
    CoursesTypes.GET_COURSE_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/courses`, { params: { course_id } }),
});

export const startCourse = (course_id: number) => ({
  types: [
    CoursesTypes.GET_START_COURSE_REQUEST,
    CoursesTypes.GET_START_COURSE_SUCCESS,
    CoursesTypes.GET_START_COURSE_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/start_course`, { params: { course_id } }),
});

export const mark_as_done = (lesson_id: number) => ({
  types: [
    CoursesTypes.MARK_AS_DONE_REQUEST,
    CoursesTypes.MARK_AS_DONE_SUCCESS,
    CoursesTypes.MARK_AS_DONE_FAILURE,
  ],
  promise: (client: any) => client.post(`/courses/mark_as_done`, { params: { lesson_id } }),
});

export const progressAction = (lesson_id: number) => ({
  types: [
    CoursesTypes.PROGRESS_REQUEST,
    CoursesTypes.PROGRESS_SUCCESS,
    CoursesTypes.PROGRESS_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/progress`, { params: { lesson_id } }),
});

export const getUserProgress = () => ({
  types: [
    CoursesTypes.GET_USER_PROGRESS_REQUEST,
    CoursesTypes.GET_USER_PROGRESS_SUCCESS,
    CoursesTypes.GET_USER_PROGRESS_FAILURE,
  ],
  promise: (client: any) => client.get(`/courses/get_user_progress`),
});
